// extracted by mini-css-extract-plugin
export default {"root":"Label_root__kpzpI","header":"Label_header__NTQp0","label":"Label_label__nESbc","error":"Label_error__XhT91"};